package com.milta.core.localization.translations.es

import com.milta.core.localization.PackageLabelScanStrings

internal val PackageLabelScan = PackageLabelScanStrings(
    scanTitle = "Escanear una etiqueta",
    analysingTitle = "Leyendo la etiqueta…",
    analysingSubtitle = "Estamos buscando el nombre, la dirección y el número de teléfono del destinatario. Solo toma unos segundos.",
    reviewTitle = "Confirmar la entrega",
    deliveryDetectedLabel = "Entrega detectada",
    allReadableLabel = "Todo legible",
    fieldToCompleteSingularSuffix = "campo por completar",
    fieldToCompletePluralSuffix = "campos por completar",
    recipientNotDetectedValue = "No detectado",
    addressNotDetectedValue = "No detectada",
    phoneNotDetectedValue = "No detectado",
    fieldRequiredWarning = "Campo obligatorio para añadir la entrega",
    recipientCorrectionPlaceholder = "Introduzca el destinatario…",
    addressCorrectionPlaceholder = "Introduzca la dirección…",
    unreadableTitle = "Etiqueta ilegible.",
    unreadableMessage = "Tome una nueva foto encuadrada en la etiqueta, bien iluminada y sin reflejos.",
    maxAttemptsMessage = "Complete esta entrega manualmente, o reinicie el escaneo con una nueva foto.",
)
